import React, { useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import './style/Marquee.css';

// تسجيل البلجن الأساسي
gsap.registerPlugin(ScrollTrigger);

// الكلمات التقنية الخاصة بـ ساسكي
const techWords = [
    { text: "SASKE EG", highlight: true },
    { text: "Fullstack Development", highlight: false },
    { text: "SASP", highlight: false },
    { text: "Django & Database", highlight: true },
    { text: "NPM & React", highlight: false },
    { text: "SASS", highlight: false },
    { text: "Scalable Apps", highlight: false },
    { text: "ERP Systems", highlight: false }
];

const InfiniteMarquee = () => {
    const containerRef = useRef(null);

    useGSAP(() => {
        // 1. شريط الصف الأول: يتحرك لليسار بشكل مستمر (من 0 إلى -50%)
        const tlLeft = gsap.to(".row-move-left", {
            xPercent: -50,
            repeat: -1,
            duration: 25,
            ease: "none"
        });

        // 2. شريط الصف الثاني: يتحرك لليمين بشكل مستمر (نبدأ من -50% إلى 0)
        gsap.set(".row-move-right", { xPercent: -50 });
        const tlRight = gsap.to(".row-move-right", {
            xPercent: 0,
            repeat: -1,
            duration: 25,
            ease: "none"
        });

        // 🎛️ السر السحري: ربط السرعة بالـ Scroll
        ScrollTrigger.create({
            trigger: containerRef.current,
            start: "top bottom",
            end: "bottom top",
            onUpdate: (self) => {
                // التقاط سرعة الـ Scroll (موجب لأسفل، سالب لأعلى)
                const scrollVelocity = self.getVelocity();
                
                // تحويل السرعة لمعامل ضرب (نحسب القيمة المطلقة حتى لا يعكس الأنميشن اتجاهه)
                // قسمة السرعة على 400 ليعطي تسارعاً متزناً غير جنوني
                const speedMultiplier = 1 + Math.abs(scrollVelocity) / 400;

                // حقن السرعة الجديدة فوراً وبنعومة في كرت الأنميشن
                gsap.to([tlLeft, tlRight], {
                    timeScale: speedMultiplier,
                    duration: 0.3,
                    overwrite: "auto"
                });

                // تراجع تدريجي وسلس للسرعة الطبيعية (1) بمجرد أن يتوقف المستخدم عن الـ Scroll
                gsap.to([tlLeft, tlRight], {
                    timeScale: 1,
                    duration: 0.8,
                    delay: 0.1,
                    overwrite: "auto"
                });
            }
        });

    }, { scope: containerRef });

    // ميثود مساعدة لتكرار الكلمات مرتين داخل نفس الصف لضمان التقاط الـ Loop اللانهائي
    const renderMarqueeGroup = () => (
        <div className="marquee-group">
            {techWords.map((word, idx) => (
                <React.Fragment key={idx}>
                    <span className={`marquee-text ${word.highlight ? 'highlight' : ''}`}>
                        {word.text}
                    </span>
                    <span className="marquee-shadow-dot"><div className="marquee-dot"></div></span>
                </React.Fragment>
            ))}
        </div>
    );

    return (
        <div ref={containerRef} className="marquee-section">
            
            {/* الصف الأول المتجه يساراً */}
            <div className="marquee-row row-move-left">
                {renderMarqueeGroup()}
                {renderMarqueeGroup()} {/* التكرار الإجباري للـ Loop السلس */}
            </div>

            {/* الصف الثاني المتجه يميناً */}
            <div className="marquee-row row-move-right">
                {renderMarqueeGroup()}
                {renderMarqueeGroup()}
            </div>

        </div>
    );
};

export default InfiniteMarquee;